// type
import { DashboardItemType } from 'types/graphql'
// constants
import { FN_TYPE_OPTIONS } from 'components/Modals/WidgetSettingsModal/components/Form/components/FunctionFields'
import { DEFAULT_CHART_TILE_HEIGHT } from 'constants/charts'

export const WIDGETS = [
  { active: true, label: 'Section', type: DashboardItemType.Section },
  { active: true, label: 'Image', type: DashboardItemType.Image },
  { active: true, label: 'Function', type: DashboardItemType.Function },
  { active: true, label: 'Card', type: DashboardItemType.Card },
  { active: true, label: 'Strategy Actions', type: DashboardItemType.StrategyActions },
  { active: true, label: 'Chart', type: DashboardItemType.Chart }
]

// Widgets that need setting up to show anything: their settings open right after they are added
export const SET_UP_ON_ADD_WIDGET_TYPES = [DashboardItemType.Card, DashboardItemType.Function, DashboardItemType.Chart]

export const SECTION_DEFAULT_SETTINGS = {
  settings: {
    dropShadow: true,
    showTitle: true,
    padding: 16,
    transparency: 1
  }
}

export const FN_DEFAULT_SETTINGS = {
  settings: {
    width: 100,
    height: 125,
    functionType: FN_TYPE_OPTIONS[0].value
  }
}

export const CARD_DEFAULT_SETTINGS = {
  settings: {
    width: 100,
    height: 125
  }
}

export const SA_DEFAULT_SETTINGS = {
  settings: {
    dropShadow: true,
    showTitle: true,
    padding: 16,
    transparency: 1
  }
}

export const CHART_DEFAULT_SETTINGS = {
  settings: {
    width: 100,
    height: DEFAULT_CHART_TILE_HEIGHT,
    showTitle: true
  }
}
